import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import ProfileComp from '../../../components/patientApp/patientChat/profile/profile'

const Profile = () => {
    return <Background>
        <ProfileComp />
    </Background>
}
export default Profile;